import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-4 pb-4 pt-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-textPrimary mb-4 text-left" }, " Selecione um modelo para importar as configurações ", -1)
const _hoisted_3 = { class: "max-h-[320px] overflow-y-auto flex flex-col gap-4" }
const _hoisted_4 = { class: "mb-3 text-left text-textPrimary" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold" }, "Unidade", -1)
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "flex flex-col gap-3" }
const _hoisted_8 = { class: "mb-2 text-left text-textPrimary pl-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold" }, "Escala", -1)
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "flex flex-col gap-2 pl-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-textPrimary" }, "Modelo", -1)
const _hoisted_15 = { class: "text-textPrimary" }
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-gray-500 text-center py-6"
}

import { ref, computed } from 'vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import RadioButton from '@/components/designSystem/RadioButton/index.vue'
import type { GroupedTemplatesResponse } from '@/Network/Types/Responses/ApprovalFlowTemplateResponses'

interface TemplateItem {
  id: number
  name: string
}

interface ScheduleWithTemplates {
  id: number
  name: string
  templates: TemplateItem[]
}

interface UnitWithSchedules {
  id: number
  name: string
  schedules: ScheduleWithTemplates[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitsAndScalesTab',
  props: {
    modelValue: {},
    groupedData: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;





const searchQuery = ref('')

const units = computed<UnitWithSchedules[]>(() => {
  return (props.groupedData ?? []).map((group) => ({
    id: group.healthUnit.id,
    name: group.healthUnit.name,
    schedules: group.schedules.map((s) => ({
      id: s.schedule.id,
      name: s.schedule.name,
      templates: s.templates.map((t) => ({
        id: t.id,
        name: t.name
      }))
    }))
  }))
})

const filteredUnits = computed(() => {
  if (!searchQuery.value) return units.value
  const q = searchQuery.value.toLowerCase()
  return units.value
    .map((unit) => ({
      ...unit,
      schedules: unit.schedules
        .map((s) => ({
          ...s,
          templates: s.templates.filter(
            (t) =>
              t.name.toLowerCase().includes(q) ||
              s.name.toLowerCase().includes(q) ||
              unit.name.toLowerCase().includes(q)
          )
        }))
        .filter((s) => s.templates.length > 0)
    }))
    .filter((unit) => unit.schedules.length > 0)
})

const handleSearch = async () => {
  // filtro local via computed
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SearchInput, {
      modelValue: searchQuery.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      label: "Buscar unidades, escalas ou modelos",
      placeholder: "Digite o nome da unidade, escala ou modelo",
      "persistent-placeholder": "",
      "search-function": handleSearch
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUnits.value, (unit) => {
        return (_openBlock(), _createElementBlock("div", {
          key: unit.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(unit.name), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.schedules, (schedule) => {
              return (_openBlock(), _createElementBlock("div", {
                key: schedule.id
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(schedule.name), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.templates, (template) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: template.id,
                      class: _normalizeClass(["flex items-center rounded-lg border px-4 py-3 cursor-pointer transition-colors", 
                  _ctx.modelValue === template.id
                    ? 'bg-[#E8F4F7] border border-primary'
                    : 'bg-[#F0F0F4] hover:bg-gray-200'
                ]),
                      onClick: ($event: any) => (_ctx.$emit('update:modelValue', template.id))
                    }, [
                      _createVNode(RadioButton, {
                        id: `template-${template.id}`,
                        name: "template-selection",
                        value: template.id,
                        "model-value": _ctx.modelValue ?? '',
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', Number($event))))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("p", _hoisted_15, _toDisplayString(template.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["id", "value", "model-value"])
                    ], 10, _hoisted_12))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128)),
      (filteredUnits.value.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Nenhum modelo encontrado "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})